import React from 'react';
import VulnerabilityAssessment from '../VulnerabilityAssessment';

const SystemLevelAssessment = () => {
  return (
    <VulnerabilityAssessment />
  )
}

export default SystemLevelAssessment